import styled from 'styled-components';
import THEME, { COLOR } from '../../styles/colors';

export const Wrapper = styled.div.attrs((props: any) => ({
  style: props.inlineStyle ? props.inlineStyle : undefined
}))`
  font-size: 14px;
  line-height: 1.3em;
  position: relative;
  padding: 0;
  border: none;
  box-sizing: border-box;
  width: 100%;
`;

const inputPadding = props => {
  let padding = '.94em 16px';
  if (!props.placeholder) padding = '8px';

  // 1.5em .8em .38em
  if (props.active) {
    padding = '2em 16px 12px';
    if (!props.placeholder) padding = '4px 8px';
  }
  return padding;
};

export const InputText = styled.input.attrs((props: any) => ({
  style: props.inlineStyle ? props.inlineStyle : undefined
}))<any>`
  outline: 0;
  line-height: 14px;
  border: 1px solid ${COLOR.neutral95};
  border-radius: 8px;
  box-sizing: border-box;
  word-break: normal;
  overflow-wrap: break-word;
  word-wrap: break-word;
  appearance: none;
  font-size: 14px;
  width: 100%;
  z-index: 2;
  margin: 0;
  transition: all 0.3s ease-out;
  padding: ${props => inputPadding(props)};
  font-size: ${props => (!props.placeholder ? '14px' : '16px')};
  background-color: ${COLOR.white};
  height: ${props =>
    props.as === 'textarea' ? 'auto' : !props.placeholder ? '32px' : '50px'};
  min-height: ${props =>
    props.as === 'textarea' ? (!props.placeholder ? '80px' : '120px') : 'auto'};
  resize: ${props =>
    props.type === 'date' || props.type === 'time' ? 'none' : 'vertical'};

  &[type='number'] {
  }
  &[type='date'] {
    padding-right: 0;
  }

  &:hover {
    background-color: ${COLOR.neutral0};
  }

  &::placeholder {
    color: ${THEME.text.secondary};
    ${'' /* opacity: ${props => (props.active ? 1 : 0)}; */}
    ${'' /* transition: opacity 0.15s cubic-bezier(0.6, 0.04, 0.98, 0.335); */}
    opacity: ${(props: any) => (!props.active ? 1 : 0)};
  }

  &:focus {
    background: ${COLOR.white};
    border: 1px solid ${props => props.theme.colors.school.primary};
  }

  &:read-only,
  &:disabled {
    -webkit-text-fill-color: ${THEME.general.disabled};
    color: ${THEME.general.disabled};
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const InputLabel = styled.label.attrs((props: any) => ({
  style: props.inlineStyle ? props.inlineStyle : undefined
}))<any>`
  position: absolute;
  opacity: 0;
  line-height: 14px;
  z-index: 1;
  display: block;
  font-size: 12px;
  top: -4px;
  color: ${COLOR.neutral30};
  transform: none;
  box-sizing: border-box;
  user-select: none;
  padding: 0 4px 0 16px;
  pointer-events: none;
  text-overflow: ellipsis;
  overflow: hidden;
  margin: 8px 0;
  width: 100%;

  transition: all 300ms ease-out;
  transform: ${(props: any) => (props.active ? 'translateY(3px)' : 'none')};
  opacity: ${(props: any) => (props.active ? 1 : 0)};

  ${InputText}:focus ~ & {
    color: ${props => props.theme.colors.school.primary};
  }
`;

export const CaptionText = styled.span`
  padding: 0 16px;
  font-size: 12px;
  line-height: 20px;
  color: ${THEME.text.primary};
`;

export const ErrorText = styled.div`
  margin-top: 5px;
  color: ${THEME.text.negative};
`;
